import { render, staticRenderFns } from "./ResearchObjectives.vue?vue&type=template&id=351907af&scoped=true"
import script from "./ResearchObjectives.vue?vue&type=script&lang=js"
export * from "./ResearchObjectives.vue?vue&type=script&lang=js"
import style0 from "./ResearchObjectives.vue?vue&type=style&index=0&id=351907af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351907af",
  null
  
)

export default component.exports